import "core-js/modules/esnext.global-this.js";
import bases from './util/bases.js';
export function toString(array) {
  var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utf8';
  var base = bases[encoding];
  if (!base) {
    throw new Error("Unsupported encoding \"".concat(encoding, "\""));
  }
  if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) {
    return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString('utf8');
  }
  return base.encoder.encode(array).substring(1);
}